import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';

export interface PermissionsForLocation {
  hasPermissionToReviewSubmissions: boolean;
  hasPermissionToManageProviders: boolean;
  neitherHasReviewSubmissionNorManageProviderPermissions: boolean;
  hasPermissionToCloneForms: boolean;
  hasFormUploadACL: boolean;
  hasViewSubmissionsACL: boolean;
  hasManageWritebackACL: boolean;
  hasManageFormsAndPacketsACL: boolean;
  hasManageTCAndPrivacyPolicyACL: boolean;
  hasViewFormsAndPacketsACL: boolean;
  hasSendFormsAndPacketsACL: boolean;
  hasDownloadPdfACL: boolean;
  hasProviderReviewACL: boolean;
}

export function getPermissionsForLocation(locationId: string): PermissionsForLocation {
  const hasProviderReviewManageACL = hasSchemaACL(locationId, Permission.FORMS_PROVIDER_REVIEW_MANAGE);
  const hasProviderReviewACL = hasSchemaACL(locationId, Permission.FORMS_PROVIDER_REVIEW);
  const hasFormClonerACL = hasSchemaACL(locationId, Permission.FORMS_CLONE_MANAGE);
  const hasFormUploadACL = hasSchemaACL(locationId, Permission.FORMS_UPLOAD_MANAGE);
  const hasManageFormsAndPacketsACL = hasSchemaACL(locationId, Permission.FORMS_MANAGE_FORMS_AND_PACKETS);
  const hasManageTCAndPrivacyPolicyACL = hasSchemaACL(locationId, Permission.FORMS_MANAGE_TC_AND_PRIVACY_POLICY);
  const hasManageWritebackACL = hasSchemaACL(locationId, Permission.FORMS_MANAGE_WRITEBACK_SYNC);
  const hasViewFormsAndPacketsACL = hasSchemaACL(locationId, Permission.FORMS_VIEW_FORMS_AND_PACKETS);
  const hasViewSubmissionsACL = hasSchemaACL(locationId, Permission.FORMS_VIEW_SUBMISSIONS);
  const hasSendFormsAndPacketsACL = hasSchemaACL(locationId, Permission.FORMS_SEND_FORMS_AND_PACKETS);
  const hasDownloadPdfACL = hasSchemaACL(locationId, Permission.FORMS_DOWNLOAD_PDF);

  // Check if the user has the permission to manage providers
  const hasPermissionToManageProviders = hasProviderReviewManageACL;

  // Check if the user has the permission to only review the submissions
  const hasPermissionToReviewSubmissions = hasProviderReviewManageACL ? false : hasProviderReviewACL;

  // Check if the user neither has the permission to manage providers nor to review the submissions
  const neitherHasReviewSubmissionNorManageProviderPermissions =
    !hasPermissionToManageProviders && !hasPermissionToReviewSubmissions;

  return {
    hasPermissionToReviewSubmissions,
    hasPermissionToManageProviders,
    neitherHasReviewSubmissionNorManageProviderPermissions,
    hasPermissionToCloneForms: hasFormClonerACL,
    hasFormUploadACL,
    hasViewSubmissionsACL,
    hasManageWritebackACL,
    hasManageFormsAndPacketsACL,
    hasManageTCAndPrivacyPolicyACL,
    hasViewFormsAndPacketsACL,
    hasSendFormsAndPacketsACL,
    hasDownloadPdfACL,
    hasProviderReviewACL,
  };
}
